import React, { Suspense, lazy } from 'react';
import ErrorBoundary from '@components/ErrorBoundary';
import { LoadingState } from '@components/marble/States';
import { Button } from '@components/ui/button';
import type { CommercialPayload } from '../types';

export const preloadPropertyMoney = () =>
  import('../PropertyMoney').then((m) => ({ default: m.PropertyMoney }));

const PropertyMoney = lazy(preloadPropertyMoney);

/** Keep a failed money chunk inside its section; reload clears a rejected lazy import. */
export function LazyPropertyMoney(props: {
  payload: CommercialPayload;
  asOf?: string;
}) {
  return (
    <ErrorBoundary
      fallback={
        <div role="alert" className="space-y-3 rounded-lg border p-4">
          <p className="text-sm font-medium">Money charts could not load</p>
          <p className="text-xs text-muted-foreground">
            Reload this page to fetch the latest charts.
          </p>
          <Button size="sm" onClick={() => window.location.reload()}>
            Reload charts
          </Button>
        </div>
      }
    >
      <Suspense fallback={<LoadingState />}>
        <PropertyMoney {...props} />
      </Suspense>
    </ErrorBoundary>
  );
}
